export class ILaya {
}
ILaya.Laya = null;
ILaya.Loader = null;
ILaya.InputManager = null;
ILaya.Scene3D = null;
ILaya.Laya3D = null;
ILaya.loader = null;
ILaya.timer = null;
ILaya.systemTimer = null;
ILaya.physicsTimer = null;
ILaya.stage = null;
